import React from 'react';
import TableRow from "./TableRow";
import TableRowColumn from "./TableRowColumn";
export default function EmptyRow(_ref) {
  var text = _ref.text,
      colSpan = _ref.colSpan;
  return React.createElement(TableRow, null, React.createElement(TableRowColumn, {
    className: "nx-table__cell--empty",
    colSpan: colSpan
  }, text));
}